import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { BudgetEmployeesFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const createEmployeeAsyncFilter = (
  apolloClient: ApolloClient<unknown>,
  budgetId: string
): FilterDefinition => ({
  label: i18n.t('budgets.detail.tabs.spendings.table.filters.employee'),
  type: 'in',
  options: {
    cache: true,
    options: async () => {
      const result = await apolloClient.query({
        query: BudgetEmployeesFilterDataDocument,
        variables: { budgetId },
        fetchPolicy: 'cache-first',
      })

      const allocations = result.data?.finance?.budgetAllocationsConnection?.edges || []
      const employees = allocations
        .map((edge) => edge.node.employee)
        .filter((emp): emp is NonNullable<typeof emp> => emp !== null)

      // Deduplicate employees
      const uniqueEmployees = Array.from(new Map(employees.map((emp) => [emp.id, emp])).values())

      return uniqueEmployees.map((emp) => ({
        label: emp.fullName,
        value: emp.id,
      }))
    },
  },
})
